import { IMGs } from '../assets/img'

export const getAvatarImage = (type?: String) => {
    return IMGs.avatar
}
